import React, { Component, PropTypes } from 'react';
import { Modal } from 'antd';
import UpdateKRForm from './update_kr_form';

class UpdateKRModal extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  formRef = (form) => {
    this.uform = form
  }

  handleOK = () => {
    const form = this.uform;
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const { title, weightE2, currentValue, description } = values;
      const params = {
        title,
        weightE2,
        currentValue,
        description,
        kid: this.props.kr.kid
      }

      if (this.props.handleOk) {
        this.props.handleOk(params);
        form.resetFields();
      }
    });
  }

  handleCancel = () => {
    const form = this.uform;
    form.resetFields();
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
  }

  render() {
    const { visible, handleOk, handleCancel, kr } = this.props;
    return (
      <Modal
        title="更新Key Result"
        visible={visible}
        okText="保存"
        cancleText="取消"
        onOk={this.handleOK}
        onCancel={this.handleCancel}
      >
        <UpdateKRForm
          ref={this.formRef}
          kr={kr}
        />
      </Modal>
    )
  }
}

export default UpdateKRModal;


// WEBPACK FOOTER //
// ./src/components/okr_manage/update_kr.js